import React from 'react'
import "./Children.scss"

function Children() {
  return (
    <div>Children</div>
  )
}

export default Children